import { CSSProperties } from 'react';

export const colors = {
  bg: '#F5F4F0',
  surface: '#FFFFFF',
  surface2: '#F0EFE9',
  surface3: '#E8E7DF',
  border: '#D8D7CE',
  borderStrong: '#B8B7AE',
  text: '#1A1917',
  text2: '#6B6A62',
  text3: '#9B9A93',
  accent: '#1A1917',
  accentText: '#F5F4F0',
  blue: '#2563EB',
  blueBg: '#EFF6FF',
  blueBorder: '#BFDBFE',
  blueText: '#1D4ED8',
  amber: '#D97706',
  amberBg: '#FFFBEB',
  amberBorder: '#FDE68A',
  amberText: '#92400E',
  red: '#DC2626',
  redBg: '#FEF2F2',
  green: '#16A34A',
  greenBg: '#F0FDF4',
  greenBorder: '#BBF7D0',
  greenText: '#15803D',
  purple: '#7C3AED',
  purpleBg: '#F5F3FF',
  purpleBorder: '#DDD6FE',
  purpleText: '#6D28D9',
};

export const drawerShell: CSSProperties = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  background: colors.surface,
  borderTop: `1px solid ${colors.border}`,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: '0 -4px 20px rgba(0,0,0,0.08)',
  zIndex: 9999,
  transition: 'height 0.28s cubic-bezier(0.4,0,0.2,1)',
};

export const drawerHandle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 20px',
  height: 44,
  flexShrink: 0,
  cursor: 'pointer',
  background: colors.surface,
  userSelect: 'none',
};

export const drawerBody: CSSProperties = {
  flex: 1,
  display: 'grid',
  gridTemplateColumns: '268px 1fr',
  overflow: 'hidden',
  minHeight: 0,
};

export const leftPanel: CSSProperties = {
  background: colors.surface,
  borderRight: `1px solid ${colors.border}`,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const rightPanel: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  background: colors.bg,
};

export const sectionHeader: CSSProperties = {
  padding: '10px 14px',
  borderBottom: `1px solid ${colors.border}`,
  flexShrink: 0,
};

export const sectionTitle: CSSProperties = {
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: colors.text3,
  marginBottom: 2,
};

export const button: CSSProperties = {
  fontSize: 12,
  fontWeight: 500,
  padding: '5px 12px',
  borderRadius: 5,
  border: `1px solid ${colors.border}`,
  background: colors.surface,
  color: colors.text,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

export const primaryButton: CSSProperties = {
  ...button,
  background: colors.accent,
  color: colors.accentText,
  borderColor: colors.accent,
};

export const modalBackdrop: CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.45)',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  zIndex: 10000,
  padding: '32px 24px',
  overflowY: 'auto',
};

export const modalContainer: CSSProperties = {
  background: colors.surface,
  borderRadius: 10,
  width: '100%',
  maxWidth: 700,
  margin: 'auto',
  overflow: 'hidden',
  boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
  flexShrink: 0,
};
